<template>
  <div class="describe">
    <div class="body2">
      <div class="right">
        <div class="t1">Respuesta rápida a tus necesidades urgentes</div>
        <div class="t2">
          Préstamo Rápido es una aplicación que ofrece servicio de préstamo
          online en forma de préstamos personales para ofrecer ayuda urgente a
          los usuarios, los procesos son sencillos y seguros.
        </div>
        <div class="t2">
          Primera opción para la rotación de fondos, desembolso menos de 3 min
          con alto crédito.
        </div>
      </div>
      <img src="@/assets/icon7.png" class="left" />
    </div>
  </div>
</template>

<script>
export default {
  name: "describeView",
    data() {
    return {};
  },


  methods: {},
};
</script>
<style scoped lang="scss">
@media (min-width: 680px) {
.describe {
  padding: 80px 0px;
   max-width: 1080px;
  width: 100%;
  margin: 0 auto;
  .title {
    font-weight: normal;
    font-size: 32px;
    color: #19191a;
    line-height: 47px;
    text-align: center;
    font-style: normal;
    text-transform: none;
  }

  .body2 {
    display: flex;
    margin-top: 134px;
    justify-content: space-around;
    .left {
      width: 344px;
      object-fit:contain;
    }
    .right {
      width: 368px;
      .t1 {
        font-weight: normal;
        font-size: 32px;
        color: #19191a;
        line-height: 47px;
        text-align: left;
        margin-bottom: 24px;
      }
      .t2 {
        font-weight: 400;
        font-size: 15px;
        color: #595959;
        line-height: 21px;
        text-align: left;
        margin-bottom: 15px;
      }
    }
  }
}
}
@media only screen and (max-width: 680px) {
  .describe {
  padding: 80px 0px;
   max-width: 1080px;
  width: 100%;
  margin: 0 auto;
  .title {
    font-weight: normal;
    font-size: 32px;
    color: #19191a;
    line-height: 47px;
    text-align: center;
    font-style: normal;
    text-transform: none;
  }

  .body2 {
    display: flex;
    margin-top: 134px;
    justify-content: space-around;
    .left {
      width: 150px;
      object-fit:contain;
    }
    .right {
      width: 200px;
      .t1 {
        font-weight: normal;
        font-size: 16px;
        color: #19191a;
        
        text-align: left;
        margin-bottom: 10px;
      }
      .t2 {
        font-weight: 400;
        font-size: 12px;
        color: #595959;

        text-align: left;
        margin-bottom: 6px;
      }
    }
  }
}
}
</style>
